import styles from "./Toggle.module.css"
const Toggle = (props) => {
    const { isOn, handleToggle, onColor, Width, id } = props

    // This is an extremely reusable component so it requires a few things to work accordingly.
  
  //1. Create a local state in the parent component that represents a value of On or Off.
      // Ex:   const [isChecked, setIsChecked] = useState(false);
  
  //2. The switch component takes a prop of isOn. Assign that prop to the local state value.
      // Ex: <Switch isOn={isChecked} />
  
  //3. The Switch component takes a function as prop for handleToggle. HandleToggle simply toggles between the state values.
      // Ex: <Switch  handleToggle={() => setIsChecked(!isChecked)} />
  
  //4. Since this is a reusable component, we can assign a color for the "On Value". (Usecase: Deleting something should be red)
      // Ex: <Switch onColor="#EF476f" />
  
  //5. Lasty, the Switch component is easily resizeable. Pass in a NUMBER value as "Width" and everything else will be calculated.
    // Ex: <Switch Width={50} />
  
    // Full example of Switch component:  <Switch isOn={isChecked} handleToggle={() => setIsChecked(!isChecked)} onColor="#EF476f" Width={50} />

  const labelStyle = Width ? `${Width}px` : "100px"
  const labelHeight = `${parseInt(labelStyle)/2}px`
  const buttonStyle = labelStyle ? `${(parseInt(labelStyle) / 2) - 5}px` : "45px"
  const onColorStyle = onColor ? onColor : "linear-gradient(90deg, #AF99FF 0%, #46B7DB 49.48%, #F13D70 100%)"




  return (
 
    <div>
      <input
        checked={isOn}
        onChange={handleToggle}
        className={styles.switch_checkbox}
        id={`${id}switch`}
        type="checkbox"
      />
      <label
        style={{
          background: isOn && onColorStyle,
          width: labelStyle,
          height: labelHeight
        }}
        className={styles.switch_label}
        htmlFor={`${id}switch`}
      >
        <span className={styles.switch_button}
          style={{ width: buttonStyle, height: buttonStyle }}
        />
          </label>
          
    </div>
  )
}

export default Toggle